module.exports = __webpack_public_path__ + "static/media/sidebar_3.05a19378.png";